import { encodeQueryObject } from "app/_helpers/helper";
import {
  DepartmentService,
  getDepartment,
} from "app/_services/UserManagement/DepartmentService";

const Constants = [
  {
    field_name: "Department",
    label: "Department Name",
    type: "string",
    isRequired: true,
  },
];

export const Constant = {
  Constants,
};

export const departmentApis = {
  getAll: {
    api: async (filter) => {
      const response = await getDepartment(encodeQueryObject(filter));

      return {
        data: response?.data?.departments || [],
        total: response?.data?.total || 0,
      };
    },
  },
  delete: {
    api: DepartmentService.deleteDepartment,
  },
};
